/**
 * Media Upload Constants
 */

export const MEDIA_UPLOAD_LIMITS = {
  MAX_IMAGES: 20,
  MAX_VIDEOS: 50,
} as const

export const PROFILE_PHOTO_LIMITS = {
  MAX_GALLERY_PHOTOS: 3,
  MAX_COVER_PHOTOS: 1,
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ["image/png", "image/jpeg", "image/jpg"],
} as const

export const PROFILE_VIDEO_LIMITS = {
  MAX_VIDEOS: 1,
  MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB
  ALLOWED_TYPES: ["video/mp4", "video/quicktime"],
} as const
